import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useRestaurants } from '../../../contexts/RestaurantsContext';
import './Menu.css';

const formatCategoryName = (category) => {
  return category.replace(/([a-z])([A-Z])/g, '$1 $2');
};

const Menu = () => {
  const { restaurantName } = useParams();
  const { restaurants } = useRestaurants();
  const restaurant = restaurants[restaurantName];

    // State for the selected menu item to show in the popup
    const [selectedItem, setSelectedItem] = useState(null);

  if (!restaurant || !restaurant.menu) {
    return <p>Menu is not available for this restaurant.</p>;
  }

  const menuSections = Object.keys(restaurant.menu);
  const midPoint = Math.ceil(menuSections.length / 2);  // Split menu into 2 halves
  const firstColumn = menuSections.slice(0, midPoint);
  const secondColumn = menuSections.slice(midPoint);

    // Handle click to show menu details in a popup
    const handleItemClick = (item) => {
      setSelectedItem(item); // Set the clicked item
    };
  
    // Handle closing the popup
    const handleClosePopup = () => {
      setSelectedItem(null); // Clear the selected item
    };

  return (
    <div className="menu-container">
      <h2>{restaurant.name} Menu</h2>
      <div className="menu-columns">
        <div className="menu-column">
          {firstColumn.map((section) => (
            <div key={section} className="menu-section">
              <h3>{formatCategoryName(section)}</h3>
              <ul>
                {restaurant.menu[section].map((item, index) => (
                  <li key={index} className="menu-item">
                    <div className="menu-item-details" onClick={() => handleItemClick(item)}>
                      <h4>{item.name}</h4>
                      <p>{item.description}</p>
                      {/* <p className="menu-item-price">${item.price}</p> */}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="menu-column">
          {secondColumn.map((section) => (
            <div key={section} className="menu-section">
              <h3>{formatCategoryName(section)}</h3>
              <ul>
                {restaurant.menu[section].map((item, index) => (
                  <li key={index} className="menu-item">
                    <div className="menu-item-details" onClick={() => handleItemClick(item)}>
                      <h4>{item.name}</h4>
                      <p>{item.description}</p>
                      {/* <p className="menu-item-price">${item.price}</p> */}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Popup Modal for item details */}
      {selectedItem && (
        <div className="popup-overlay" onClick={handleClosePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-button" onClick={handleClosePopup}>
              <div>x</div>
            </span>
            <h3>{selectedItem.name}</h3>
            <p>{selectedItem.description}</p>
            <p>{selectedItem.detailedDescription}</p>
            <p>{selectedItem.detailedDescription2}</p>
            {/* Add more item details if available */}
            {/* <p>Price: ${selectedItem.price}</p> */}
          </div>
        </div>
      )}

    </div>
  );
};

export default Menu;
